
import { ImagePreview } from 'vant'
import { getTime, transform } from '../../../assets/js/xjpublic';
import { errorModal } from '../../../assets/js/xjcommon';
import { jsSdk } from '../../../assets/libs/loadjs';
// 引入高德地图(方法一,有问题)
// import AMap from 'AMap';
// 引入高德地图(方法二,可以使用)
// import {AMap} from '../../../assets/libs/loadjs';

export default {
  name: 'home',
  components: {
    [ImagePreview.name]: ImagePreview
  },
  data() {
    return {
      mediaList: [],
      showAddress: '',
      isNoData: false,
      // 分享相关
      // 分享标题
      shareTitle: '',
      shareLocation: '',
      // 分享图标
      urlThumb: '',
      // 分享地址传参,任务ID或列表
      queryField: '',
      // 分享地址传参,查询的字段名称
      queryID: '',
      // 是否是分享页面
      sharePage: false,
      player: '',
      isshow: false,
      d3Type: '',
      isangle: window.orientation === 90 || window.orientation === -90,
      key: Math.random(),
    }
  },
  methods: {
    // 预览照片
    previewImageFn(imgUrl) {
      ImagePreview({
        images: [imgUrl],
        startPosition: 0
      });
    },
    // 根据任务ID(task_id)或列表ID(_id)去获取照片或视频数据
    initMediaListFn(queryID, queryField, customer, key) {
      let _this = this;
      this.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中...'
      });
      const requestBody = { [queryField]: queryID, isNeedLocation: 1, isShare: this.sharePage, customer }
      if (key) requestBody.key = key
      this.$axios.post('/v3/u/album/shareDetail', requestBody, { params: { customer } })
        .then((response) => {
          // console.log(response);
          if (response.data.ret === 0) {
            // 加载状态结束
            let resData = response.data.data;
            // debugger;
            resData = resData.filter((item) => { return ![100, 101].includes(item.type) }).sort((a, b) => a.camera - b.camera); // 过滤行程报告(100)和斑马附件(101)
            if (resData.length) {
              // let posData = [0, 0];
              for (let i = 0; i < resData.length; i++) {
                resData[i].photoTypeText = transform.photoType(resData[i].type);
                resData[i].cameraTypeText = resData[i].camera ? transform.cameraType(resData[i].camera) : '';
                resData[i].showTime = resData[i].create_time ? getTime.getFormatDate(2, resData[i].create_time) : '';
                // 停车图片/停车视频时间优先使用trigger_time
                if ((resData[i].type === 9 || resData[i].type === 10) && resData[i].trigger_time) {
                  resData[i].showTime = getTime.getFormatDate(2, resData[i].trigger_time);
                }
                // // 获取地址坐标信息
                // if (resData[0].hasOwnProperty('pos') && resData[0].pos[0] && resData[0].pos[0] !== 0 && !posData[0]) {
                //   posData = [resData[0].pos[0], resData[0].pos[1]];
                // }
              }
              this.mediaList = resData;
              // 分享相关
              // 分享标题媒体类型
              // _this.shareTitle = transform.photoType(resData[0].type);
              // 分享标题媒体类型
              this.shareTitle = _this.$store.state.customerName + (resData[0].mtype === 1 ? '图片' : '视频') + '分享';
              // 分享图标(有多个资源时显示第一张)
              this.urlThumb = resData[0].url_thumb;
              this.shareLocation = resData[0].location
              // 自定义分享(此时有分享图标)
              this.shareSetFn(customer);
              // 解析地址
              // 判断是否存在坐标点
              // if (resData[0].hasOwnProperty('pos')) {
              //   if( resData[0]['location'] ){
              //     _this.showAddress = resData[0]['location'];
              //   }else{
              //     transform.pointToAddress(posData[0], posData[1], 1, function (res) {
              //       if (res.code === 0) {
              //         _this.showAddress = res.address;
              //       } else {
              //         _this.showAddress = '未上传地址信息';
              //       }
              //     });
              //   }
              // } else {
              //   _this.showAddress = '拍摄地址已关闭';
              // }

              // 关闭加载状态
              this.$toast.clear();
            } else {
              this.$notify({
                message: '云存储空间满，数据已被删除',
                duration: 0,
                background: '#ff3300'
              });
              // 关闭加载状态
              this.$toast.clear();
            }
          } else {
            this.$toast.clear();
            // 3. 首先判断albumType，不是发现交警相册按原逻辑处理
            // 4. albumType为发现交警 并且 ts和当前时间比对，小于2分钟，提示视频正在上传中，请过一会儿再来查看
            // 5. albumType为发现交警 并且 ts和当前时间比对，大于2分钟小于1个月，提示视频未成功上传
            // 6. albumType为发现交警 并且 ts和当前时间比对，大于1个月，提示被循环覆盖了
            let message = response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取信息失败（' + response.data.ret + '）'
            const albumType = this.$route.query.albumType;
            const timeUpload = this.$route.query.ts;
            if (Number(albumType) === 20) {
              const timeDiff = new Date().getTime() - timeUpload;
              const oneMonth = 24 * 30 * 60 * 60 * 1000;
              const twoMinutes = 2 * 60 * 1000;
              if (timeDiff > oneMonth) {
                message = '资源已被循环覆盖'
              }
              if (timeDiff < twoMinutes) {
                message = '视频正在上传中，请过一会儿再来查看'
              }
              if (timeDiff <= oneMonth && timeDiff >= twoMinutes) {
                message = '视频未成功上传'
              }
            }
            this.$dialog({
              message
            })
          }
        })
        .catch((error) => {
          this.$toast.clear();
          errorModal(error, 171);
        })
    },
    transformHandle(id, type) {
      transform.regeoAddress(id, type, (res) => {
        if (res.code === 0) {
          this.mediaList = this.mediaList.map(item => ({ ...item, location: id === item._id ? res.address : item.location }))
        }
      });
    },
    // 自定义分享
    shareSetFn(customer) {
      jsSdk(customer, ['updateAppMessageShareData', 'updateTimelineShareData']).then((wx)=>{
        if (this.shareLocation) {
          // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容(安卓可以设置成功,IOS设置会失败)
          this.customShare(this.shareLocation,customer)
        } else {
          const firstItem = this.mediaList[0];
          transform.regeoAddress(firstItem._id, firstItem.type, (res) => {
            this.customShare(res.address,customer)
          })
        }
      });
    },
    customShare(location,customer) {
      // 分享描述
      let baseLink = window.location.origin;
      // 分享图标
      let shareImgUrl = this.urlThumb;
      wx.updateAppMessageShareData({
        title: this.shareTitle || '图片/视频分享', // 分享标题
        desc: location, // 分享描述
        link: baseLink + '/showMedia?' + this.queryField + '=' + this.queryID + '&customer=' + customer + '&share=share', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: shareImgUrl, // 分享图标
        success: function () {
          // 设置成功
          console.log('ShowMedia - 设置成功111');
        },
        fail:  (res) =>{
          console.log('ShowMedia - fail:' + JSON.stringify(res));
          if (/offline/i.test(res.errMsg)) {
            // ios报错:the permission value is offline verifying
            // ios报错:updateAppMessageShareData:the permission value is offline verifying
            // ios报错原因：ISO上微信只识别了主页地址，而不是当前页面地址(与vue的push跳转有关).解决方法：刷新一次(必须多加一个参数才有效,如&xj=xj)
            // let nowLink =  window.location.origin + '/share?scene=pickup&xj=xj';
            // window.location.replace(nowLink);
          }
        }
      });
      // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容(安卓可以设置成功,IOS设置会失败)
      wx.updateTimelineShareData({
        title: this.shareTitle || '图片/视频分享', // 分享标题
        link: baseLink + '/showMedia?' + this.queryField + '=' + this.queryID + '&customer=' + customer + '&share=share', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: shareImgUrl, // 分享图标
        success: function () {
          // 设置成功
          console.log('ShowMedia - 设置成功222');
        },
        fail:  (res)=>{
          console.log('ShowMedia - fail-two:' + JSON.stringify(res));
          if (/offline/i.test(res.errMsg)) {
            // ios报错:the permission value is offline verifying
            // ios报错:updateAppMessageShareData:the permission value is offline verifying
            // ios报错原因：ISO上微信只识别了主页地址，而不是当前页面地址(与vue的push跳转有关).解决方法：刷新一次(必须多加一个参数才有效,如&xj=xj)
            // let nowLink =  window.location.origin + '/share?scene=pickup&xj=xj';
            // window.location.replace(nowLink);
          }
        }
      });
    },
    change3DImg(item, id = 'demoImage') {
      setTimeout(() => {
        this.player = new EapilRender(document.getElementById(id), {
          DataType: EapilRender.DATATYPE.IMG,
          SourceUrl: item.url,
          Template: item.cameraTemplate
        });
      }, 180)
    },
    change3DVideo(item, id = 'd3Video') {
      setTimeout(() => {
        this.player = new EapilRender(document.getElementById(id), {
          poster: item.thumb,
          DataType: EapilRender.DATATYPE.MP4,
          RoateXY: { xValue: 0, yValue: 0 },
          SourceUrl: item.url,
          Template: item.cameraTemplate,
        });
      }, 180)
    },
    fullScreenHandle(item, type) {
      window.scroll(0, 0);
      document.body.style.overflow = 'hidden'
      this.isshow = true;
      this.d3Type = item.mtype;
      this.d3item = item;
      this[type](item, 'demoVideo')
    },
    closeHandle() {
      document.body.style.overflow = 'auto'
      this.cleanCache()
      this.isshow = false;
      this.key = Math.random();
    },
    cleanCache() {
      try {
        this.player.destroy()
      } catch (error) {
        document.getElementById('demoVideo').innerHTML = ''
      }
    },
    actionHandle() {
      this.isangle = screen.orientation.angle === 90;
      if (this.isshow) {
        this.cleanCache()
        // 旋转屏幕之后 重新绘制
        if (this.d3Type === 1) {
          this.change3DImg(this.d3item, 'demoVideo')
        }
        if (this.d3Type === 2) {
          this.change3DVideo(this.d3item)
        }
      } else {
        // window.location.href=window.location.href+"&id="+10000*Math.random();
        if (!document.webkitIsFullScreen) {
          this.key = Math.random();
        }
      }
    },
  },
  created() {

  },
  mounted() {
    // 获取页面传参
    // 任务ID或列表
    let queryID = this.$route.query.task_id || this.$route.query._id || this.$route.query.taskId || this.$route.query._id;
    let key = this.$route.query.key;
    // 查询的字段名称
    let queryField = (this.$route.query._id || this.$route.query.id) ? 'id' : 'taskId';
    let customer = this.$route.query.customer || this.$store.state.customer;
    this.queryID = queryID;
    this.queryField = queryField;
    // 是否是分享页面
    this.$route.query.share ? this.sharePage = true : '';
    if (queryID) {
      // 请求数据
      this.initMediaListFn(queryID, queryField, customer, key);
      // 自定义分享(此时还没有分享图标)
      // this.shareSetFn();
    } else {
      this.$notify({
        message: '参数错误',
        duration: 0,
        background: '#ff3300'
      })
    }
    window.addEventListener('orientationchange', this.actionHandle, false);
  },
  destroyed() {
    this.$notify.clear();
    window.removeEventListener('orientationchange', this.actionHandle);
  },
  computed: {
    defaultImg() {
      return 'this.src="' + require('../../../assets/images/img_default01.png') + '"';
    }
  }
}
